import React, { FC, ReactNode } from "react";
import useTourNavigation from "../../hooks/useTourNavigation";

interface Props {
  children: ReactNode;
}

/**
 * HOC that handles tour navigation from URL parameters
 * This component uses the useTourNavigation hook to navigate to specific
 * trail/point/orientation when the tour data is loaded
 */
const TourNavigator: FC<Props> = ({ children }) => {
  // Use the tour navigation hook to handle URL-based navigation
  useTourNavigation();

  // Simply render children - all navigation logic is handled by the hook
  return <>{children}</>;
};

export default TourNavigator;
